import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ErrorResponse } from "react-router-dom";
import { RegisterBusinessForm } from "shared/types";
import { getApiSuccessMessage, getApiErrorMessage } from "shared/utils";
import { translate } from "shared/languages";
import client from "shared/utils/axios-config";

export const useRegisterBusiness = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (registerForm: RegisterBusinessForm) => {
      return client.post("/v1/business", registerForm);
    },
    onSuccess: ({ data: response }) => {
      getApiSuccessMessage("Registration Successful.");
      queryClient.invalidateQueries({ queryKey: ["business"] });
    },
    onError: (error: AxiosError<ErrorResponse>) => {
      getApiErrorMessage(error);
    },
  });
};

export const useUpdateBusiness = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      businessId,
      form,
    }: {
      businessId: string;
      form: RegisterBusinessForm;
    }) => {
      return client.put(`/v1/business/${businessId}`, form);
    },
    onSuccess: () => {
      getApiSuccessMessage(
        `${translate("title.business_profile")} ${translate(
          "messages.success.update",
        )}`,
      );
      queryClient.invalidateQueries({ queryKey: ["business"] });
    },
    onError: (error: AxiosError<ErrorResponse>) => {
      getApiErrorMessage(error);
    },
  });
};
